import { Dropdown, MenuButton, Menu, MenuItem } from "@mui/joy";
import { create } from "zustand";

import ArchiveBreakdown from "./ArchiveBreakdown";
import { ArchiveTimeSeries } from "./ArchiveTimeSeries";

const useAnalysisTypeStore = create<{
  analysisType: "timeSeries" | "traitBalance" | "gradeBalance";
  setAnalysisType: (type: "timeSeries" | "traitBalance" | "gradeBalance") => void;
}>((set) => ({
  analysisType: "timeSeries" as "timeSeries" | "traitBalance" | "gradeBalance",
  setAnalysisType: (type: "timeSeries" | "traitBalance" | "gradeBalance") =>
    set({ analysisType: type }),
}));

const labelMap = {
  gradeBalance: "Grade Spread",
  traitBalance: "Trait Balance",
  timeSeries: "Time Series",
};

export const ArchiveAnalysisTypeSelector = () => {
  const { analysisType, setAnalysisType } = useAnalysisTypeStore();
  return (
    <Dropdown>
      <MenuButton size="sm">Analysis Type: {labelMap[analysisType]}</MenuButton>
      <Menu>
        <MenuItem onClick={() => setAnalysisType("gradeBalance")}>Grade Spread</MenuItem>
        <MenuItem onClick={() => setAnalysisType("traitBalance")}>Trait Balance</MenuItem>
        <MenuItem onClick={() => setAnalysisType("timeSeries")}>Time Series</MenuItem>
      </Menu>
    </Dropdown>
  );
};

const ArchiveGraphs = () => {
  const { analysisType } = useAnalysisTypeStore();

  if (analysisType === "timeSeries") {
    return <ArchiveTimeSeries />;
  } else if (analysisType === "gradeBalance" || analysisType === "traitBalance") {
    return <ArchiveBreakdown presetId={analysisType} />;
  }
};

export default ArchiveGraphs;
